import React from 'react';

import SubmenuModelLink from '@/components/layouts/header/submenu-model-link';
import { Divider } from '@/components/shared/element/divider';
import { HeadingLevel1 } from '@/components/shared/element/headline/heading-level-1';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';
import { Flex } from '@/components/shared/layout/flex';
import { Grid } from '@/components/shared/layout/grid';
import { Section } from '@/components/shared/layout/section';
import { IMenu } from '@/types/layout/menu';
import { IButton } from '@/types/shared';

export interface SectionDownloadBrochureProps {
  title?: string;
  description?: string;
  buttons?: IButton[];
  submenu?: IMenu[];
  submenu2?: IMenu[];
}

const View = ({
  title,
  description,
  buttons = [],
  submenu,
}: SectionDownloadBrochureProps) => {
  const handleDownload = (url: string) => {
    window.open(url);
  };

  return (
    <Section test="section_download_brochure">
      <HeadingLevel1
        title={title ?? ''}
        description={description}
        buttons={buttons}
      />
      <Container>
        {submenu?.map((o, submenuIndex) => (
          <React.Fragment key={submenuIndex}>
            <Divider variant="gray" />
            <Box paddingY={{ '@initial': '8', '@lg': '12' }}>
              <Grid templateColumns={{ '@lg': '12' }} columnGap="6" rowGap="4">
                {!!o.label && (
                  <Text
                    as="h2"
                    size="text-sub-h2"
                    font="bold"
                    variant="text-gray"
                    css={{
                      '@lg': { gridColumn: '1 / span 2' },
                    }}
                  >
                    {o.label}
                  </Text>
                )}
                {o.submenu && o.submenu.length > 0 && (
                  <Box
                    css={{
                      '@lg': { gridColumn: '3 / span 10' },
                      '@xl': { gridColumn: '3 / span 9' },
                    }}
                  >
                    <Grid
                      templateColumns={{ '@initial': '2', '@md': '3' }}
                      columnGap={{ '@initial': '4', '@xs': '6', '@lg': '12' }}
                      rowGap={{ '@initial': '6', '@lg': '12' }}
                    >
                      {o.submenu?.map(
                        (sub, subIndex) =>
                          sub.submenu &&
                          sub.submenu.length > 0 && (
                            <React.Fragment key={subIndex}>
                              {sub.submenu.map((subsub, subsubIndex) => (
                                <Flex
                                  direction="column"
                                  key={subsubIndex}
                                  onClick={() =>
                                    handleDownload(subsub.brochure ?? '')
                                  }
                                  css={{
                                    maxWidth: '$size-52',
                                    cursor: 'pointer',
                                  }}
                                  data-track="download-brochure"
                                  data-track-text={subsub.label}
                                  data-track-url={subsub.brochure}
                                  data-test="download-brochure-link"
                                  data-hover
                                >
                                  <Text
                                    as="h3"
                                    size="text-body-2"
                                    font="bold"
                                    variant="text-gray"
                                  >
                                    {sub.label}
                                  </Text>
                                  <Box
                                    css={{
                                      height: '100%',
                                      alignItems: 'flex-end',
                                      '& > *:first-child': {
                                        marginBottom: 'auto',
                                      },
                                    }}
                                  >
                                    <SubmenuModelLink
                                      label={subsub.label}
                                      image={
                                        subsub.image
                                          ? {
                                              ...subsub.image,
                                              priority: submenuIndex === 0,
                                            }
                                          : undefined
                                      }
                                      forBrochure={true}
                                      new={subsub.new}
                                      dataTrack="download-brochure"
                                      dataTest="download-brochure-link"
                                    />
                                  </Box>
                                </Flex>
                              ))}
                            </React.Fragment>
                          )
                      )}
                    </Grid>
                  </Box>
                )}
              </Grid>
            </Box>
          </React.Fragment>
        ))}
      </Container>
    </Section>
  );
};

View.displayName = 'SectionDownloadBrochure';
export default View;
